<template>
  <a-list-item :key="item.id" class="objects-list-item">
    <a-badge-ribbon :color="getRibbonColor(item)" :text="getRibbonText(item)">
      <a-badge-ribbon
        v-for="(badge, index) in computedBadges"
        :key="index"
        :color="badge.color"
        :text="badge.text"
        :placement="badge.placement"
        :class="badge.class"
      >
        <preview-image-card
          v-if="index === computedBadges.length - 1"
          v-bind="imageCardProps"
          @update-select-all="updateSelectAllCall"
        />
      </a-badge-ribbon>

      <preview-image-card
        v-if="computedBadges.length === 0"
        v-bind="imageCardProps"
        @update-select-all="updateSelectAllCall"
      />
    </a-badge-ribbon>
  </a-list-item>
</template>
<script>
import PreviewImageCard from './PreviewImageCard.vue';
export default {
  components: {
    PreviewImageCard,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    staticImage: {
      type: Object,
      required: true,
    },
    segmentId: {
      type: [String, Number],
      required: true,
    },
    presignedUrlList: {
      type: Object,
      required: true,
    },
    selectImage: {
      type: Boolean,
      required: true,
    },
    getFileName: {
      type: Function,
      required: true,
    },
    openAnnotationModal: {
      type: Function,
      required: true,
    },
    deleteAnnotation: {
      type: Function,
      required: true,
    },
    getRibbonColor: {
      type: Function,
      required: true,
    },
    getRibbonText: {
      type: Function,
      required: true,
    },
    getImagetItemIndex: {
      type: Function,
      required: true,
    },
  },
  emits: ['updateSelectAll'],

  computed: {
    imageCardProps() {
      return {
        'image-obj': this.item,
        'presigned-url': this.presignedUrlList,
        index: this.getImagetItemIndex(this.item),
        'select-all': this.selectImage,
        'get-file-name': this.getFileName,
        'open-annotation-modal': this.openAnnotationModal,
        'delete-annotation': this.deleteAnnotation,
      };
    },
    computedBadges() {
      const badges = [];

      // Static Frame
      if (this.staticImage[this.item.id]) {
        badges.push({
          color: 'cyan',
          text: 'Static',
          placement: 'start',
          class: '',
        });
      }

      // Segmented
      if (this.item.id === this.segmentId) {
        badges.push({
          color: 'cyan',
          text: 'Segmented',
          placement: 'end',
          class: 'mt-5',
        });
      }

      // Requires Review
      if (this.item.requires_review) {
        badges.push({
          color: '#e3a805',
          text: 'Review Required',
          placement: 'start',
          class: 'mt-5',
        });
      }

      // Requires Propagation Review
      if (this.item.requires_propagation_review) {
        // This needs to be placed after a "Review Required" badge if both exist.
        // To maintain the original stacking order, we can check for an existing badge.
        const prevClass = badges.length > 0 ? 'mt-7' : 'mt-5';
        badges.push({
          color: '#E3A805',
          text: 'Propagation Review Required',
          placement: 'start',
          class: prevClass,
        });
      }
      return badges;
    },
  },
  methods: {
    updateSelectAllCall(value) {
      this.$emit('updateSelectAll', value);
    },
  },
};
</script>
<style scoped>
.mt-7 {
  margin-top: 7rem !important;
}
</style>
